import { firebaseConfig } from "./config/runtimeConfig";

export default firebaseConfig;
